import { AfterViewInit, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IdbService } from './services/idb.service';
import { PwaService } from './services/pwa.service';
import { LocalStorageService } from './services/local-storage.service';
import { UserDataStringResponse } from './model/response/user/user';
import { LoginService } from './features/login/login.service';
import { HubService } from './services/web-socket/hub.service';
import { AuthService } from './services/auth.service';
import { SessionService } from './services/session.service';
import { ToastService } from './core/toast/toast.service';
import { BrowserDetectorService } from './services/browser-detector.service';
import { SideBarService } from './features/sidebar/sidebar.service';
import { ModuleBaseResponse } from './model/response/modules/modules-menu';
import { Subject, take, takeUntil } from 'rxjs';
import { RolesResponse } from './model/roles';
import { GlobalService } from './services/global.service';
import { BaseResponse } from './model/response/base-response';
import { SidebarComponent } from './features/sidebar/sidebar.component';
import { trigger, style, transition, animate } from '@angular/animations';
import { SettingsService } from './features/settings/settings.service';
import { AppGlobalSettings } from './features/settings/settings';
import { CurrentSessionId, User } from './features/login/login';

export declare var navigator: any;


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [
    SidebarComponent,
  ], animations: [
    trigger('themeChangeOpacity', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('300ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ opacity: 0 }))
      ])
    ]),
    trigger('themeChange', [
      transition('false => true', [
        style({ 'background': 'transparent' }),
        animate('500ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ 'background': '#000' }))
      ]),
      transition('true => false', [
        style({ 'background': 'transparent' }),
        animate('500ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ 'background': '#fff' }))
      ])
    ]),
  ],
  standalone: false
})

export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  title: string = environment.appName;
  showLoader: boolean = false;
  textReady: boolean = false;
  loaderLogo: string = `${environment.baseHREF}${environment.logo}`
  networkStatus: boolean = true; //true = online  false = offline
  showFetchPopup: boolean = false;
  reloading: boolean = false;
  ignoreButton: boolean = false;
  theEnd$: Subject<void> = new Subject<void>();
  themeReady: boolean = false;
  triggerAnimation: boolean = false;
  dark: boolean = false;


  cssPath: string = environment.theme.darkThemePath;

  constructor(public pwaService: PwaService,
    private idbService: IdbService,
    private localStorageService: LocalStorageService,
    private sessionService: SessionService,
    private browserD: BrowserDetectorService,
    private globalService: GlobalService,
    private settingsService: SettingsService,
    private loginService: LoginService
  ) {

    // regiser locale IT as default
    this.sessionService.registerCulture('it-IT');

    //checks if the device is offline every 5 seconds
    window.setInterval(() => {
      if (navigator.connection) {
        if (navigator.connection.downlink >= 1) {
          this.browserD.connectionStatus$.next(true);
        } else {
          if (navigator.connection.effectiveType == '4g' || navigator.connection.effectiveType == '3g') {
            this.browserD.connectionStatus$.next(true);
          } else {
            this.browserD.connectionStatus$.next(false);
          }
        }
      }
    }, 5000);

    //IDB CONNECTION
    if (environment.idbOptions)
      this.idbService.connectToIDB(environment.idbOptions.name, environment.idbOptions.items, environment.idbOptions.version);

    //CUSTOM COLORS GENERATOR FOR THEME
    this.globalService.themeColors();

    //block scroll when opening sidebar or when you need it

    this.globalService.blockScroll.pipe(takeUntil(this.theEnd$)).subscribe({
      next: (block: boolean) => {
        console.log(block)

        if (block == false) {
          console.log('ITS OPEN')
          document.getElementById('global-content-container')?.classList.add('overflow-hidden', 'fixed', 'w-screen')
        } else {
          console.log('ITS CLOSED')
          document.getElementById('global-content-container')?.classList.remove('overflow-hidden', 'fixed', 'w-screen')
        }


      }
    })


  }


  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    //this.barcodeWidth =

    if (window.innerHeight > window.innerWidth) {
      this.globalService.isMobile$.next(true);
    } else {
      this.globalService.isMobile$.next(false);
    }
  }

  ngOnDestroy(): void {
    this.theEnd$.unsubscribe();
  }

  themeReturn(): string {
    return this.cssPath;
  }

  ngOnInit(): void {

    //get session and other things from token
    let tokens = this.localStorageService.getTokens();
    if (tokens) {
      //if tokens there is access and refresh
      this.loginService.getCurrentSession(tokens.refreshToken).pipe(take(1)).subscribe({
        next: (response: CurrentSessionId) => {
          this.localStorageService.saveGUID(response.sessionId);
          //get the session data
          this.loginService.getCurrentUserProfile().pipe(take(1)).subscribe({
            next: (userResponse: User) => {
              this.localStorageService.saveUserData(userResponse);
            },
            error: () => {
              //this.localStorageService.clearSession();
            }
          })
        }, error: () => {
          //this.localStorageService.clearSession();
        }
      })
    } else {
      this.localStorageService.clearSession();
    }


    // creo connessione con websocket
    // this.hub.startConnection();
    // this.hub.getTestData();
    // this.hub.getUserState();

    // update app settings
    if (this.localStorageService.getTokens() != null) {
      this.updateLocalAppSettings();
    }


  }

  updateLocalAppSettings() {

    // check if settings exist in the idb
    this.idbService.getAllData(environment.idbTables.GlobalSettings).then((res: any) => {
      console.warn("\n \n \n GOT THE DATA FROM IDB FOR SETTINGS \n \n \n");
      console.warn(res);

      if (res != undefined) {
        let resData: Array<any> = res;
        if (resData.length == 0) {

          this.settingsService.GetSettings().pipe(takeUntil(this.theEnd$)).subscribe({
            next: (res: AppGlobalSettings) => {

              if (res != undefined) {

                // update or create settings in local idb
                this.idbService.addItemRow(environment.idbTables.GlobalSettings, res, environment.idbTables.GlobalSettings);

              } else {
                console.error("\n \n \n \n \n SHIT \n THERE ARE NO SETTINGS 💀💀💀💀💀💀💀💀💀💀💀💀💀💀 \n \n \n \n \n");
              }

            },
            error: () => {

            }
          });

        } else {
          console.info("SETTINGS ARE SETTED lol");
        }
      }

    });



  }

  //code for animation on theme change
  setDarkMode() {

    //this.themeReady = false;

      this.localStorageService.setAppTheme('dark');
        this.globalService.dark(true);
        this.dark = true;
        return;

    switch (this.localStorageService.getAppTheme()) {
      case 'dark': {
        this.globalService.dark(true);
        this.dark = true;
        break;
      };
      case 'light': {
        this.globalService.dark(false);
        this.dark = false;
        break;
      };
      case 'system': {
        this.globalService.dark(this.globalService.isDark());
        this.dark = this.globalService.isDark();
        break;
      };
      default: {
        this.localStorageService.setAppTheme('dark');
        this.globalService.dark(false);
        this.dark = false;
      }
    }



    if (this.triggerAnimation == true) { // prevents animation on first load 
      setTimeout(() => {
        this.themeReady = true;
      }, 1000);
    } else {
      this.themeReady = true;
    }
  }


  ngAfterViewInit(): void {



    this.globalService.imageChange.pipe(takeUntil(this.theEnd$)).subscribe({
      next: (val: string) => {
        setTimeout(() => {
          if (val == environment.logoDark) {
            this.dark = true;
          } else {
            this.dark = false;
          }
        }, 100);

        this.themeReady = false;
        setTimeout(() => {
          this.themeReady = true;
        }, 1000);
      }
    })

    const darkModePreference = window.matchMedia("(prefers-color-scheme: dark)");
    darkModePreference.addEventListener("change", () => this.setDarkMode());
    this.setDarkMode()
    this.triggerAnimation = true // prevents animation on first load 


    console.error("\n INIZIO CONTROLLO SU VERSIONE \n");

    // this.globalService.getAppInfoAndClearCache(environment.version).pipe(takeUntil(this.theEnd$)).subscribe({
    //   next: (res: BaseResponse) => {
    //     console.error("\n this is the response \n");
    //     console.error(res);
    //     if (res.error != environment.version) {
    //       this.reloading = true;
    //       let refreshed = this.localStorageService.getValue('refreshed');
    //       if (refreshed == 'true') {
    //         this.ignoreButton = true;
    //       }
    //     }
    //   }
    // });

  }


  refreshPage() {

    location.reload();

  }


}
